
import { defineComponent } from "vue";
import { required, maxLength, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import numOnly from "@/utils/validations/numOnly";
import moment from "moment";
import messages from "@/config/messages";
import common from "@/config/common";
import routesPath from "@/config/routesPath";
import TokenService from "@/services/tokenService";
import * as apiClient from "@/apiclient/";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "ParticipantOtpValidationView",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      isFormInvalid: false,
      verificationCode: "",
      emailAddress: "",
      countdown: this.getCountDownTimer(),
      validationMsg:
        "You entered an incorrect or expired code. Please try again or click RESEND CODE to receive a new code.",
      isSubmitDisabled: false,
      otpResponseMessage: "We have sent a verification code to",
      isResponseValid: true,
      messages,
      routesPath,
      searchParticantToken: "",
    };
  },
  validations() {
    return {
      verificationCode: {
        required,
        numOnly,
        maxLength: maxLength(6),
        minLength: minLength(6),
      },
    };
  },
  mounted() {
    this.timerCountdown();
  },
  computed: {
    formatedCountdown(): string {
      return moment(this.countdown, "seconds").format("m:ss");
    },
    resendTextEnable(): string {
      return this.countdown ? "disabled" : "";
    },
  },
  methods: {
    ...mapGetters(["getMaskedEmailAddress"]),
    getCountDownTimer() {
      const otpTimer = sessionStorage.getItem(common.storageVariables.otpTimer);
      return otpTimer ? Number(otpTimer) : Number(common.otpTimer);
    },
    hideErrors(field: string): void {
      this.v$[field].$touch();
      this.isFormInvalid = false;
    },
    timerCountdown(): void {
      const stopCountdown = setInterval(() => {
        if (this.countdown > 0) this.countdown -= 1;
        sessionStorage.setItem(
          common.storageVariables.otpTimer,
          this.countdown.toString()
        );
        if (!this.countdown) clearInterval(stopCountdown);
      }, 1000);
    },
    resendCode(): void {
      if (this.countdown == 0) {
        const responseData = this.sendOtp().catch.length;
        if (responseData > 0) {
          this.otpResponseMessage = "We have re-sent a verification code to";
          this.countdown = Number(common.otpTimer);
          this.timerCountdown();
        }
      }
    },
    buttonDesign(): string {
      const buttonStatus = this.v$.verificationCode.$invalid;
      console.log("buttonStatus", buttonStatus);
      return buttonStatus == true ? "btn-secondary" : "btn-primary";
    },
    async sendOtp(): Promise<void> {
      const params = {
        emailAddress: this.emailAddress,
      };
      this.searchParticantToken = TokenService.getToken(
        "SearchParticantToken"
      )!;

      const result = await apiClient
        .searchParticipantController()
        .postApiSearchparticipantResendVerificationCode({
          headers: {
            Authorization: "Bearer " + this.searchParticantToken,
            "Content-Type": "application/json",
          },
        });

      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else {
        this.isFormInvalid = false;
        this.isResponseValid = true;
      }
    },
    async otpVerification(): Promise<void> {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      const params = {
        code: this.verificationCode,
      };
      this.isSubmitDisabled = true;
      this.searchParticantToken = TokenService.getToken(
        "SearchParticantToken"
      )!;

      const result = await apiClient
        .searchParticipantController()
        .postApiSearchparticipantCodeVerification(params, {
          headers: {
            Authorization: "Bearer " + this.searchParticantToken,
            "Content-Type": "application/json",
          },
        });

      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else if (result.data) {
        if (result.data.success === true) {
          TokenService.logout();
          TokenService.setAccessToken(result.data.token!.token as string);
          TokenService.setRefreshToken(
            result.data.token!.refreshToken as string
          );
          this.$router.push({
            name: routesPath.enrollments,
          });
        } else {
          this.isFormInvalid = true;
        }
      }

      this.isSubmitDisabled = false;
      this.verificationCode = "";
      this.v$.verificationCode.$reset();
    },
  },
});
